import { isCampaignLandingPath } from "../constants/campaign-pages";

const ORDER_HOST = "order.simplysalad.com";

export const isOrderSimplySaladUrl = (url = "") =>
  typeof url === "string" && url.includes(ORDER_HOST);

export const trackGaEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  window.gtag("event", eventName, params);
};

export const trackGptPageView = (pathname = "") => {
  const path =
    pathname ||
    (typeof window !== "undefined" ? window.location.pathname : "");

  if (!isCampaignLandingPath(path)) return;

  trackGaEvent("gpt_page_view", { page_path: path });
};

export const trackGptClickOrder = ({
  linkUrl = `https://${ORDER_HOST}/`,
  ctaLocation = "cta",
} = {}) => {
  if (typeof window === "undefined") return;
  if (!isCampaignLandingPath(window.location.pathname)) return;

  trackGaEvent("gpt_click_order", {
    link_url: linkUrl,
    cta_location: ctaLocation,
    page_path: window.location.pathname,
  });
};
